(function(){
    angular
        .module('appback')
        .directive('ngSwiper', swiperS);

        swiperS.$inject = ['$timeout'];
        function swiperS($timeout){
            return {
              scope:{
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                  console.log(element, 'dunction swiper')
                    new Swiper('.swiper-angular', {
                        slidesPerView: 'auto',
                        spaceBetween: 8,
                        freeMode: true,
                        navigation: {
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                        },
                      });
                });
            }
          }
      }
})();